import { defineStore } from 'pinia'
import { clearToken, getToken, setToken } from '../services/request'
import * as authApi from '../services/api/auth'
import type { ProxyUser } from '../services/api/types'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: getToken(),
    user: null as ProxyUser | null,
  }),
  getters: {
    isAuthenticated: (state) => Boolean(state.token),
  },
  actions: {
    async login(payload: { username: string; password: string }) {
      const token = await authApi.login(payload)
      this.token = token
      setToken(token)
      await this.fetchMe()
    },
    async register(payload: { username: string; password: string; accessIp: string }) {
      await authApi.register(payload)
    },
    async fetchMe() {
      this.user = await authApi.me()
    },
    async logout() {
      try {
        await authApi.logout()
      } finally {
        this.token = null
        this.user = null
        clearToken()
      }
    },
  },
})
